// /*
//  * Broadcast Theme — refills.js
//  * Loaded only on product.refill-pdp template via Liquid.
//  */

// // ─────────────────────────────────────────────
// // SHARED UTILS
// // ─────────────────────────────────────────────
// const _moCallbacks = new Set();
// new MutationObserver(() => _moCallbacks.forEach(fn => fn()))
//   .observe(document.body, { childList: true, subtree: true });

// function onDomChange(fn)  { _moCallbacks.add(fn); }
// function offDomChange(fn) { _moCallbacks.delete(fn); }

// function getThumbs() {
//   return Array.from(document.querySelectorAll(
//     '.product__thumb a, .product__thumb__link, a.product_thumb, .product-thumb a, .product-thumbs a'
//   )).filter(el => el.offsetParent !== null);
// }

// function safeClick(el) {
//   if (!el) return;
//   const a = el.closest('a') || el.querySelector('a') || el;
//   setTimeout(() => a.click(), 10);
// }

// function getRow(btn) {
//   return btn.closest('[data-variant-id]') ||
//          btn.closest('[data-variant-id-row]') ||
//          btn.closest('[data-variant]');
// }

// function getVariantId(row) {
//   return row.getAttribute('data-variant-id') || row.getAttribute('data-variant');
// }


// // ─────────────────────────────────────────────
// // 0. FORCE REFILLS MODE
// // Makes the scent selector behave as refills-only
// // (no bundle limit, min 3)
// // ─────────────────────────────────────────────
// document.addEventListener('DOMContentLoaded', () => {
//   const btn = document.querySelector('#option-refills');
//   if (!btn) return;
//   // Temporarily make it visible so click registers, then hide again
//   const parent = document.querySelector('#purchase-options');
//   if (parent) parent.style.display = 'flex';
//   btn.click();
//   if (parent) parent.style.display = 'none';
// });


// // ─────────────────────────────────────────────
// // 1. SLIDE SYNC
// // Image 1 = generic, Images 2-5 = per variant
// // ─────────────────────────────────────────────
// document.addEventListener('DOMContentLoaded', () => {
//   const map = {
//     '51074269184334': 1, // scent 1
//     '51074269217102': 2, // scent 2
//     '51074269249870': 3, // scent 3
//     '51074269282638': 4  // scent 4
//   };

//   document.body.addEventListener('click', e => {
//     const btn = e.target.closest('.big-plus, .add, button.add');
//     if (!btn) return;
//     const row = getRow(btn);
//     if (!row) return;
//     const idx = map[getVariantId(row)];
//     if (!idx) return;
//     requestAnimationFrame(() => safeClick(getThumbs()[idx - 1]));
//   });

//   function watchQuantity(row) {
//     const input = row.querySelector('.quantity-input');
//     if (!input || input._watched) return;
//     input._watched = true;
//     let last = input.value;
//     new MutationObserver(() => {
//       const val = parseInt(input.value, 10);
//       if (val === 0 && last !== '0') safeClick(getThumbs()[0]);
//       last = String(val);
//     }).observe(input, { attributes: true, childList: true, characterData: true });
//   }

//   document.body.addEventListener('click', e => {
//     const btn = e.target.closest('.minus-btn, .minus, .minus-button, .quantity__minus');
//     if (!btn) return;
//     const row = getRow(btn);
//     if (!row) return;
//     watchQuantity(row);
//     setTimeout(() => {
//       const input = row.querySelector('.quantity-input');
//       if (input && parseInt(input.value, 10) === 0) safeClick(getThumbs()[0]);
//     }, 80);
//   });
// });


// // ─────────────────────────────────────────────
// // 2. HIDE UPSELL + FIRST + LAST 3 THUMBS
// // ─────────────────────────────────────────────
// (function () {
//   function hideExtras() {
//     document.querySelectorAll('.product__block.upsell-products')
//       .forEach(el => { el.style.display = 'none'; });

//     const first = document.querySelector('.product__thumbs__holder .product__thumb:first-child');
//     if (first) first.style.display = 'none';

//     // const thumbs = Array.from(document.querySelectorAll('.product__thumb'));
//     // if (thumbs.length >= 3) thumbs.slice(-3).forEach(el => { el.style.display = 'none'; });
//   }

//   hideExtras();
//   onDomChange(hideExtras);
// })();


// // ─────────────────────────────────────────────
// // 3. PSWP LIGHTBOX THUMB FILTER
// // ─────────────────────────────────────────────
// document.addEventListener('DOMContentLoaded', () => {
//   const HIDE = [1, 9, 10, 11];

//   function filterPswp() {
//     const all = document.querySelectorAll('.pswp__thumbs figure');
//     if (!all.length) return;
//     HIDE.forEach(n => { const t = all[n - 1]; if (t) t.style.display = 'none'; });
//   }

//   onDomChange(filterPswp);
// });


// // ─────────────────────────────────────────────
// // 4. SLIDE REMOVAL (positions 2,3,4,9,10,11)
// // ─────────────────────────────────────────────
// document.addEventListener('DOMContentLoaded', () => {
//   const REMOVE = [9, 10, 11];

//   function removeSlides() {
//     const all = document.querySelectorAll('.product__slide');
//     if (all.length < 11) return;
//     REMOVE.slice().sort((a, b) => b - a).forEach(n => all[n - 1]?.remove());
//     offDomChange(removeSlides);
//   }

//   onDomChange(removeSlides);
// });


// // ─────────────────────────────────────────────
// // 5. GALLERY FILTER (show only variant images)
// // ─────────────────────────────────────────────
// document.addEventListener('DOMContentLoaded', () => {
//   const KEEP_IDS = ['52539702739278', '52539706671438', '52539712110926', '52539727020366'];

//   function applyGalleryFilter() {
//     const slides = document.querySelectorAll('.product__slide');
//     const thumbs = document.querySelectorAll('.product__thumb-item');
//     if (!slides.length) return;

//     slides.forEach(s => { s.classList.add('media--hidden'); s.classList.remove('media--active'); s.style.display = 'none'; });
//     thumbs.forEach(t => { t.style.display = 'none'; });

//     KEEP_IDS.forEach((id, i) => {
//       slides.forEach(s => {
//         const mid = s.getAttribute('data-media-id') || '';
//         if (s.getAttribute('data-image-id') === id || mid.includes(id)) {
//           s.style.display = '';
//           s.classList.toggle('media--active', i === 0);
//           s.classList.toggle('media--hidden', i !== 0);
//         }
//       });
//       thumbs.forEach(t => {
//         const mid = t.getAttribute('data-media-id') || '';
//         if (t.getAttribute('data-image-id') === id || mid.includes(id)) {
//           t.style.display = '';
//           t.classList.toggle('is-active', i === 0);
//           if (i !== 0) t.classList.remove('active');
//         }
//       });
//     });

//     document.querySelector('.product__slides')
//       ?.querySelectorAll('.product__slide[style*="display: none"]')
//       .forEach(s => s.remove());
//     document.querySelector('.product__thumbs, .product-thumbs, .product__thumb-list')
//       ?.querySelectorAll('.product__thumb-item[style*="display: none"]')
//       .forEach(t => t.remove());
//   }

//   applyGalleryFilter();

//   function onChange() {
//     if (document.querySelectorAll('.product__slide').length >= 4) {
//       applyGalleryFilter();
//       offDomChange(onChange);
//     }
//   }
//   onDomChange(onChange);
// });








/*
 * Broadcast Theme — refills.js
 * Loaded only on product.refill-pdp template via Liquid.
 *
 * UPDATED: 1st (generic / non-variant) image is no longer hidden.
 *   Minimal changes vs. original:
 *     - Section 2: removed the line that hid the first .product__thumb
 *     - Section 3: removed `1` from the PSWP HIDE list
 *     - Section 5: kept the original whitelist logic, but also treat
 *                  slides[0] / thumbs[0] (the generic) as "keep" so they
 *                  aren't hidden or removed. Active state stays on the
 *                  generic on first render — exactly one slide is active.
 *     - Section 1: shifted the variant→thumb index by +1 because
 *                  getThumbs() now starts with the generic at index 0.
 */

// ─────────────────────────────────────────────
// SHARED UTILS
// ─────────────────────────────────────────────
const _moCallbacks = new Set();
new MutationObserver(() => _moCallbacks.forEach(fn => fn()))
  .observe(document.body, { childList: true, subtree: true });

function onDomChange(fn)  { _moCallbacks.add(fn); }
function offDomChange(fn) { _moCallbacks.delete(fn); }

function getThumbs() {
  return Array.from(document.querySelectorAll(
    '.product__thumb a, .product__thumb__link, a.product_thumb, .product-thumb a, .product-thumbs a'
  )).filter(el => el.offsetParent !== null);
}

function safeClick(el) {
  if (!el) return;
  const a = el.closest('a') || el.querySelector('a') || el;
  setTimeout(() => a.click(), 10);
}

function getRow(btn) {
  return btn.closest('[data-variant-id]') ||
         btn.closest('[data-variant-id-row]') ||
         btn.closest('[data-variant]');
}

function getVariantId(row) {
  return row.getAttribute('data-variant-id') || row.getAttribute('data-variant');
}


// ─────────────────────────────────────────────
// 0. FORCE REFILLS MODE
// ─────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const btn = document.querySelector('#option-refills');
  if (!btn) return;
  const parent = document.querySelector('#purchase-options');
  if (parent) parent.style.display = 'flex';
  btn.click();
  if (parent) parent.style.display = 'none';
});


// ─────────────────────────────────────────────
// 1. SLIDE SYNC
// Visible thumb order is now: [generic, scent1, scent2, scent3, scent4]
// so variant idx 1..4 maps to getThumbs()[1..4].
// minus → 0 falls back to getThumbs()[0] (generic).
// ─────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const map = {
    '51074269184334': 1, // scent 1
    '51074269217102': 2, // scent 2
    '51074269249870': 3, // scent 3
    '51074269282638': 4  // scent 4
  };

  document.body.addEventListener('click', e => {
    const btn = e.target.closest('.big-plus, .add, button.add');
    if (!btn) return;
    const row = getRow(btn);
    if (!row) return;
    const idx = map[getVariantId(row)];
    if (idx === undefined) return;
    requestAnimationFrame(() => safeClick(getThumbs()[idx]));
  });

  function watchQuantity(row) {
    const input = row.querySelector('.quantity-input');
    if (!input || input._watched) return;
    input._watched = true;
    let last = input.value;
    new MutationObserver(() => {
      const val = parseInt(input.value, 10);
      if (val === 0 && last !== '0') safeClick(getThumbs()[0]);
      last = String(val);
    }).observe(input, { attributes: true, childList: true, characterData: true });
  }

  document.body.addEventListener('click', e => {
    const btn = e.target.closest('.minus-btn, .minus, .minus-button, .quantity__minus');
    if (!btn) return;
    const row = getRow(btn);
    if (!row) return;
    watchQuantity(row);
    setTimeout(() => {
      const input = row.querySelector('.quantity-input');
      if (input && parseInt(input.value, 10) === 0) safeClick(getThumbs()[0]);
    }, 80);
  });
});


// ─────────────────────────────────────────────
// 2. HIDE UPSELL
// (NOTE: first-thumb hiding has been removed so the generic shows.)
// ─────────────────────────────────────────────
(function () {
  function hideExtras() {
    document.querySelectorAll('.product__block.upsell-products')
      .forEach(el => { el.style.display = 'none'; });
  }

  hideExtras();
  onDomChange(hideExtras);
})();


// ─────────────────────────────────────────────
// 3. PSWP LIGHTBOX THUMB FILTER
// 1st thumb is no longer hidden in the lightbox.
// ─────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const HIDE = [9, 10, 11];

  function filterPswp() {
    const all = document.querySelectorAll('.pswp__thumbs figure');
    if (!all.length) return;
    HIDE.forEach(n => { const t = all[n - 1]; if (t) t.style.display = 'none'; });
  }

  onDomChange(filterPswp);
});


// ─────────────────────────────────────────────
// 4. SLIDE REMOVAL (positions 9, 10, 11)
// ─────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const REMOVE = [9, 10, 11];

  function removeSlides() {
    const all = document.querySelectorAll('.product__slide');
    if (all.length < 11) return;
    REMOVE.slice().sort((a, b) => b - a).forEach(n => all[n - 1]?.remove());
    offDomChange(removeSlides);
  }

  onDomChange(removeSlides);
});


// ─────────────────────────────────────────────
// 5. GALLERY FILTER
// Keep: slides[0] (generic) + the 4 KEEP_IDS variants.
// Exactly one slide is active at a time → slides[0] on first render.
// ─────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const KEEP_IDS = ['52539702739278', '52539706671438', '52539712110926', '52539727020366'];

  function isWhitelisted(el) {
    const id  = el.getAttribute('data-image-id') || '';
    const mid = el.getAttribute('data-media-id') || '';
    return KEEP_IDS.some(k => id === k || mid.includes(k));
  }

  function applyGalleryFilter() {
    const slides = document.querySelectorAll('.product__slide');
    const thumbs = document.querySelectorAll('.product__thumb-item');
    if (!slides.length) return;

    let activeAssigned = false;

    slides.forEach((s, i) => {
      const keep = i === 0 || isWhitelisted(s);
      if (keep) {
        s.style.display = '';
        s.classList.remove('media--hidden');
        if (!activeAssigned) {
          s.classList.add('media--active');
          activeAssigned = true;
        } else {
          s.classList.remove('media--active');
          s.classList.add('media--hidden');
        }
      } else {
        s.style.display = 'none';
        s.classList.add('media--hidden');
        s.classList.remove('media--active');
      }
    });

    let firstThumbDone = false;
    thumbs.forEach((t, i) => {
      const keep = i === 0 || isWhitelisted(t);
      if (keep) {
        t.style.display = '';
        if (!firstThumbDone) {
          t.classList.add('is-active');
          firstThumbDone = true;
        } else {
          t.classList.remove('is-active', 'active');
        }
      } else {
        t.style.display = 'none';
      }
    });

    // Remove anything still hidden so layout collapses to just the kept items
    document.querySelector('.product__slides')
      ?.querySelectorAll('.product__slide[style*="display: none"]')
      .forEach(s => s.remove());
    document.querySelector('.product__thumbs, .product-thumbs, .product__thumb-list')
      ?.querySelectorAll('.product__thumb-item[style*="display: none"]')
      .forEach(t => t.remove());
  }

  applyGalleryFilter();

  // Force the generic (1st) thumb to be the active slide on initial load.
  // The theme's own gallery slider can re-pick "active" after we filter,
  // so we explicitly click the 1st visible thumb once everything has settled.
  let initialActivationDone = false;
  function activateFirstThumbOnce() {
    if (initialActivationDone) return;
    const first = getThumbs()[0];
    if (!first) return;
    initialActivationDone = true;
    safeClick(first);
  }
  // Try a few times to outlast the theme's own init
  setTimeout(activateFirstThumbOnce, 150);
  setTimeout(() => { initialActivationDone = false; activateFirstThumbOnce(); }, 600);

  function onChange() {
    if (document.querySelectorAll('.product__slide').length >= 4) {
      applyGalleryFilter();
      offDomChange(onChange);
    }
  }
  onDomChange(onChange);
});